<template>
  <div class="single_wrap clearfix">
    <div class="titleBiao">课件制作</div>
    <div class="top">
      <div class="fl_left">
        <div class="wzbarBox">
          <div class="wzbar" v-for="(item,index) in danceItem" @click="selectDance(item)"
               :class="{'wzbars':item.id==curDanceId}">
            <div>{{ item.name }}
              <span v-if="item.type == 0">（考级）</span>
              <span v-else-if="item.type == 1">（美育）</span>
              <span v-else>（其他）</span>
              <template v-if="item.id==curDanceId">
                <el-dropdown @command="setDance">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#c30d23"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">
                      <Icon type="ios-create-outline"></Icon>
                      编辑科目
                    </el-dropdown-item>
                    <el-dropdown-item command="delete" divided>
                      <Icon type="md-trash"></Icon>
                      删除科目
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </div>
            <span></span>
          </div>
        </div>
      </div>
      <el-button icon="el-icon-plus" type="info" @click="dialogFormVisible = true">添加科目</el-button>
      <el-dialog width="500px" title="提示" :visible.sync="dialogFormVisible" :before-close="hiddenTips">
        <el-form :model="form">
          <el-form-item label="科目名称" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off" placeholder="请输入科目名称" maxlength="10"
                      show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="科目类型" :label-width="formLabelWidth">
            <el-select v-model="form.type" clearable filterable placeholder="请选择科目类型">
              <el-option v-for="item in formData" :label="item.name" :value="item.value" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hiddenTips">取 消</el-button>
          <el-button type="primary" @click="addDance">确 定</el-button>
        </div>
      </el-dialog>
      <div class="clear"></div>
    </div>
    <div class="center fl_left" v-if="package_content">
      <div class="content">
        <div class="single_top clearfix">
          <div class="left_tit fl_left">
            <span v-model="name">{{ name }}</span>
            <span>共{{ total }}级</span>
            <span v-model="lesson">共{{ lesson }}节课</span>
          </div>
          <div class="addBtns fl_right" @click="addstage()">新建分级</div>

        </div>
        <div v-if="packagelist.length==0" class="single_con"
             style="background-color:#fff;text-align:center;padding:200px 0 400px;">
          您还没有级别，请点击右上角“ 增加级别 ”，进行添加！
        </div>
        <div v-else class="single_con">
          <div v-if="packagelist" v-for="(item,key) in packagelist" :key="key"
               style="padding:30px;margin-bottom: 20px;background:#fff;">
            <!-- <Tooltip content="点击添加课节" style="width:100%;" placement="top" offset="0,-20"> -->
            <div class="list_lesson" v-model="packagelist">
              <div class="clearfix" @click.stop="specific_con($event,key)">
                <div class="imgSrc fl_left">
                  <img :src="item.cover" :onerror="defaultImg" alt="">
                  <p class="fa_bu">
                    <!-- 编辑中editoring  发布中  已发布 -->
                    <img v-if="item.status == 2" src="static/imgs/fabu.png" alt="">
                    <img v-if="item.status == 1" src="static/imgs/release.png" alt="">
                    <img v-if="item.status == 3" src="static/imgs/released.png" alt="">
                    <!-- <img v-else-if="item.status==1" src="../../static/imgs/releaseing.png" alt=""> -->
                  </p>
                </div>
                <div class="right_lesson fl_left">
                  <div class="lesson clearfix">
                    <div class="fl_left lesson_Q">{{ item.name }}<span style="color:#000"
                                                                       v-if="item.level_id != 'ac925162vx84bd6v898e'">·</span>{{ item.level }}
                    </div>
                    <div class="fl_left lesson_price">￥{{ item.price }}</div>
                  </div>
                  <div class="lesson_Q lesson_intro">{{ item.introduce }}</div>
                  <div class="lesson_Q" v-if="item.pack_time">发布时间：{{ item.pack_time }}</div>
                  <div class="lesson_Q">{{ item.lesson_num }}节课<span>/已填{{ item.added_num }}节课</span></div>
                  <div class="pos_btn">
                    <span @click.stop="specific_con($event,key)" class="hover_color">添加课节</span>
                    <span @click.stop="edit($event,key)" class="hover_color">编辑</span>
                    <span @click.stop="delet($event,key)" class="hover_color">删除</span>
                    <span @click.once="release($event,key)" class="hover_color">发布</span>
                  </div>
                </div>
              </div>
              <div class="loading_wrap_con">
                <div class="loading_content">
                  <i class="el-icon-loading"></i>
                  <div>发布中，请耐心等待</div>
                </div>
              </div>
              <!-- <div class="loading_wrap" v-if="item.status==3 || item.status==5" @click="showTishi($event)"></div> -->
            </div>
            <!-- </Tooltip> -->
          </div>
          <div style="position: relative;background-color:#fff;height:80px;">
            <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage"
                  style="position:absolute;bottom:20px;left:38%;"></Page>
          </div>

        </div>
      </div>
    </div>
    <div class="center fl_left" v-if="edit_add">
      <edits :dancelist='formdate' :danceId="curDanceId" @edits="bb"></edits>
    </div>
    <!-- <div class="center fl_left" v-if="total_num">
      <addlessons :tablelist="formdate" @addkjs="aa"></addlessons>
    </div> -->
    <!-- <div class="center fl_left" v-if="addpar">
      <modify :listcourse_id="infcon" ref="load" @modifystage="cc"></modify>
    </div> -->
  </div>
</template>
<script>
import edits from './editDances'
// import modify from './modifyinfo'
import addlessons from './addKj'

export default {
  data() {
    return {
      pageSize: 5,
      total: 0,
      pageNum: 0,
      cate_id: '',
      show: false,
      loading: false,
      defaultImg: 'this.src="' + require('../../../static/imgs/img_moren.png') + '"',
      course_name: '',
      packagelist: [],
      edit_add: false,
      package_content: true,
      name: '',
      stage: '',
      lesson: '',
      total_num: false,
      // addpar:false,
      formdate: {
        course_id: "",
        keys: 0,
        package_id: '',
        package_nam: '',
        lesson_num: '',
        num: 0,
        is_money: 0,
      },
      msg: 0,
      index: '', //类目选中下表
      danceItem: [], //舞种列表

      curDance: '', //当前舞种
      curDanceId: '', //当前舞种
      addDanceModel: {
        dance_id: '',
        name: '',
        type: ''
      },
      dialogFormVisible: false,
      form: {
        name: '',
        type: ''
      },
      formData: [
        {
          id: "00001",
          name: "考级课件",
          value: 0
        },
        {
          id: "00002",
          name: "美育课件",
          value: 1
        }
      ],
      formLabelWidth: '70px'
    }
  },
  components: {
    edits,
    // modify,
    addlessons
  },
  methods: {
    updatePage(num) {
      this.pageNum = num;
      this.default_event(0);
    },
    goback(index) {
      if (index == 1) {
        // this.$router.go(-3);
        this.$router.push({
          path: '/manager/stu_class/class',
        })
      }
    },
    showTishi(e) {
      e.stopPropagation()
      this.$alert('该级正在发布中，请耐心等待', {
        confirmButtonText: '确定',
      })
    },
    specific_con(e, i) {
      e.stopPropagation();
      let _this = this;
      _this.package_content = false;
      _this.total_num = true;
      _this.edit_add = false;
      // _this.addpar=false;
      _this.formdate.package_id = _this.packagelist[i].id;
      _this.formdate.package_name = _this.packagelist[i].name;
      _this.formdate.lesson_num = _this.packagelist[i].lesson_num;
      _this.formdate.num = _this.packagelist.length;
      _this.formdate.course_id = this.packagelist[i].id;
      _this.formdate.is_money = this.packagelist[i].is_money;
      localStorage.setItem('table_list', JSON.stringify(_this.formdate))
      this.$router.push({
        path: '/manager/stu_class/class/singleLesson/addKj',
        query: {
          // cate_id:params.row.id,
          // name:params.row.name,
        }
      })
    },
    bb(msg) {
      const _this = this;
      if (msg === 'false') {
        msg = false
      } else {
        msg = true
      }
      this.edit_add = msg;
      this.package_content = true;
      // this.addpar=msg;
      _this.default_event(1);
    },
    aa(msgs) {
      const _this = this;
      this.package_content = true;
      this.total_num = false;
      this.edit_add = false;
    },
    add() {
      this.show = true
    },
    get_course_request(i) {
      let _this = this;
      if (_this.course_name == "") {
        _this.$message.error('类目名称不可为空')
      } else {
        _this.$axios.post('addcourse', {course_name: _this.course_name}).then(res => {
          if (res.data.code == 200) {
            _this.$message.success('添加成功')
            _this.cancel()
            _this.get_dance_list()
          } else {
            _this.$message.error(res.data.message)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    addstage() {
      this.edit_add = true;
      this.package_content = false;
      this.formdate.keys = {
        cate_id: this.cate_id,
        id: null
      }
    },
    cancel() {
      this.show = false;
      this.course_name = '';
    },

    //编辑
    edit(e, i) {
      e.stopPropagation();
      this.edit_add = true;
      this.package_content = false;
      this.formdate.keys = this.packagelist[i]
      // this.infcon.keys=i;
    },
    //删除
    delet(e, i) {
      e.stopPropagation();
      const _this = this;
      this.$confirm('此操作将永久删除该级别所有内容, 是否继续?', '提示', {
        onfirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$axios.post('deleteissue', {
          issue_id: _this.packagelist[i].id
        }).then((res) => {
          if (res.data.code == 200) {
            _this.$message.success('删除成功!');
            _this.packagelist.splice(i, 1)
          } else {
            _this.$message.error(res.data.message)
          }

        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //发布
    release(e, i) {
      const _this = this;
      e.stopPropagation();
      $('.list_lesson').eq(i).find('.loading_wrap_con').show()
      _this.$axios.post('publishissue', {
        issue_id: _this.packagelist[i].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.packagelist[i].status = 2;//未刷接口
          $('.list_lesson').eq(i).find('.loading_wrap_con').hide()
        } else {
          _this.$message.error(res.data.message);
          $('.list_lesson').eq(i).find('.loading_wrap_con').hide()
        }
      })
    },
    default_event(index) {
      const _this = this;
      if (index == 1) {
        _this.pageNum = 1;
      }
      _this.$axios.post('getissuelist', {
        // cate_id:_this.cate_id,
        page: _this.pageNum,
        dance_id: _this.curDanceId
      }).then((res) => {
        if (res.data.code == 200) {
          _this.packagelist = res.data.data.list;
          _this.lesson = res.data.data.table_count;
          _this.total = res.data.data.total;
        } else {
          _this.$message.error(res.data.message)
        }

      }).catch(error => {
        console.log(error)
      })
    },
    //修改舞种
    selectDance(item) {
      const _this = this;
      _this.curDance = item;
      _this.curDanceId = item.id;
      _this.default_event(1);
    },
    //获取科目舞种
    getDanceList() {
      const _this = this;
      _this.$axios.post('getdancelist', {}).then((res) => {
        if (res.data.code == 200) {
          _this.danceItem = res.data.data;
          if (_this.danceItem.length > 0 && !_this.curDanceId) {
            _this.curDanceId = _this.danceItem[0].id;
            _this.default_event(1);
          }
        } else {
          _this.$message.error(res.data.message)
        }

      }).catch(error => {
        console.log(error)
      })
    },
    //shezhi
    setDance(command) {
      const _this = this;
      if (command == 'edit') {
        // _this.editDance();
        _this.showTips();
      } else {
        _this.$confirm('此操作将永久删除该科目', '提示', {
          onfirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$axios.post('deletedance', {
            dance_id: _this.curDanceId
          }).then((res) => {
            if (res.data.code == 200) {
              _this.$message.success("删除成功");
              _this.curDanceId = '';
              _this.getDanceList();
            } else {
              _this.$message.error(res.data.message)
            }

          }).catch(error => {
            console.log(error)
          })
        }).catch(() => {
        });
      }
    },
    //添加舞种
    addDance() {
      const _this = this;
      _this.addDanceModel.name = _this.form.name;
      _this.addDanceModel.type = _this.form.type;
      _this.saveDance();
      _this.hiddenTips();

      // _this.addDanceModel = {
      // 	name:'',
      // };
      // _this.$prompt('请填写科目名称', '提示', {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消',
      // }).then(({ value }) => {
      // 	_this.addDanceModel.name = value;
      // 	_this.saveDance();
      // }).catch(() => {

      // });
    },

    hiddenTips() {
      const _this = this;
      _this.dialogFormVisible = false;
      _this.addDanceModel = {
        dance_id: '',
        name: '',
        type: '',
      };
      _this.form = {
        name: '',
        type: '',
      };
    },

    showTips() {
      const _this = this;
      _this.dialogFormVisible = true;
      _this.addDanceModel = {
        dance_id: _this.curDance.id,
        name: _this.curDance.name,
        type: _this.curDance.type,
      };
      _this.form = {
        name: _this.curDance.name,
        type: _this.curDance.type,
      };
    },

    //添加舞种
    editDance() {
      const _this = this;
      _this.addDanceModel = {
        dance_id: _this.curDance.id,
        name: _this.curDance.name,
      };
      _this.$prompt('请填写科目名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: _this.curDance.name
      }).then(({value}) => {
        _this.addDanceModel.name = value;
        _this.saveDance();
      }).catch(() => {

      });
    },
    //保存舞种
    saveDance() {
      const _this = this;
      _this.$axios.post('adddance', _this.addDanceModel).then((res) => {
        if (res.data.code == 200) {
          _this.$message.success("成功");
          _this.getDanceList();
        } else {
          _this.$message.error(res.data.message)
        }

      }).catch(error => {
        console.log(error)
      })
    },
  },
  created() {
    const _this = this;
    // _this.cate_id=this.$route.query.cate_id;
    _this.name = this.$route.query.name;
    _this.getDanceList();
  },
  watch: {
    $route(to, from) {
      //路由是否跳转
      console.log(this.$route.path);
    }
  }
};
</script>
<style scoped>
/**/
.titleBiao {
  line-height: 68px;
  color: #303030;
  font-size: 18px;
}

/*.single_wrap{min-width: 1152px;margin: 0 auto;width: 75%;}*/
.center {
  width: 100%;
}

.single_top {
  height: 64px;
  line-height: 64px;
  box-sizing: border-box;
  padding: 0 30px; /*border-radius: 4px;*/
  background: #fff;
}

.addBtns {
  width: 102px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  margin-top: 14px;
  background: #c30d23;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
}

.list_lesson {
  width: 100%;
  position: relative;
  cursor: pointer;
}

.single_con {
  margin-top: 10px;
  box-sizing: border-box;
  position: relative;
}

.list_lesson:hover {
  background: #f5f5f5;
}

/*.right_lesson:hover .pos_btn{display: block;}*/
.imgSrc {
  position: relative;
  width: 210px;
  height: 142px;
  text-align: center;
  line-height: 142px;
}

.fa_bu {
  width: 54px;
  height: 26px;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 26px;
}

.imgSrc img {
  max-width: 210px;
  max-height: 142px;
  display: inline-block;
  vertical-align: middle;
}

.right_lesson {
  box-sizing: border-box;
  width: calc(100% - 210px);
  padding-left: 26px;
  position: relative;
  height: 142px;
}

.lesson_price {
  margin-left: 231px;
  line-height: 30px;
}

.lesson_Q {
  line-height: 30px;
}

.lesson_Q > span {
  color: rgba(1, 171, 108, 1);
  font-weight: bold;
}

.lesson_intro {
  width: 395px;
  height: 57px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.pos_btn {
  position: absolute;
  top: 50%;
  right: 49px;
  color: #1890ff;
  font-size: 14px;
  display: block;
  margin-top: -20px;
}

.pos_btn span {
  margin-left: 20px;
  cursor: pointer;
}

.list_manage_wrap {
  width: 210px;
  border-radius: 4px;
  background: #fff;
  margin-right: 20px;
}

.top_tit {
  font-size: 14px;
  height: 52px;
  line-height: 52px;
  border-bottom: 1px solid #f5f5f5;
  text-indent: 29px;
  position: relative;
}

.add_list {
  width: 292px;
  height: 172px;
  background: #fff;
  box-shadow: -1px -1px 10px rgba(0, 0, 0, 0.09), 1px 1px 10px rgba(0, 0, 0, 0.09);
  position: absolute;
  bottom: -176px;
  right: -235px;
  padding: 0 30px;
  box-sizing: border-box;
  z-index: 100;
}

.add_list:after {
  position: absolute;
  top: -20px;
  left: 30px;
  content: "";
  border-color: transparent transparent #fff transparent;
  border-style: solid;
  border-width: 10px;
}

.add_list:before {
  position: absolute;
  top: -24px;
  left: 28px;
  content: "";
  border-color: transparent transparent rgba(0, 0, 0, 0.09) transparent;
  border-style: solid;
  border-width: 12px;
}

.title {
  line-height: 44px;
  text-align: center;
  text-indent: 0
}

.ipt {
  width: 230px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding-left: 13px;
  box-sizing: border-box;
}

.ok_q {
  background: rgba(1, 171, 108, 1);
  color: #fff;
  font-size: 14px;
}

.btn {
  width: 106px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  border: none;
  outline: none;
  border-radius: 4px;
  cursor: pointer;
}

.cancle {
  background: #fff;
  border: 1px solid #ddd;
  margin-left: 13px;
}

.adds {
  margin-left: 92px;
  font-size: 20px;
  color: rgba(1, 171, 108, 1);
  cursor: pointer;
  font-weight: bold;
}

.total_cl {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
}

.left_tit > span:first-child {
  display: inline-block;
  margin-right: 5px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.toatls {
  border-radius: 4px;
  width: 170px;
  height: 34px;
  border: 1px dashed #bfbfbf;
  line-height: 34px;
  text-align: center;
  color: #666;
  cursor: pointer;
  font-size: 12px;
}

.bor_left {
  background: #01AB6C;
  color: #fff;
}

.loading_wrap_con {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 999;
  display: none;
}

.loading_content {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translateX(-50%) translateY(-50%);
  font-size: 24px;
  color: #1759d2;
  text-align: center;
  font-size: 30px
}

.loading_content div {
  font-size: 24px;
}

.top, .center, .bottom, .bottomBox {
  width: 100%;
}

.top {
  height: 62px;
  line-height: 62px;
  border-bottom: 1px solid #e6e6e6;
  /*padding: 0 20px;*/
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  background: #ffffff;
  padding-left: 20px;
}

.wzbarBox {
  display: flex;
  display: -webkit-flex;
  justify-content: space-around;
  align-items: center;
  height: 61px;
}

.wzbar {
  color: #999;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: column;
  line-height: 58px;
  cursor: pointer;
  padding: 0 20px;
}

.wzbar > span {
  display: block;
  width: 120px;
  height: 3px;
  background-color: #f6f6f6;
}

.wzbars {
  color: #c30d23;
}

.wzbars > span {
  background-color: #c30d23;
}
</style>
<style>
/*.el-table__empty-block{display: none;}*/
.el-loading-mask {
  width: 100%;
  height: 100%;
}

.el-loading-mask {
  position: absolute;
}

.el-loading-spinner {
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/index/singleLesson.vue